import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import BaseChannelSerializer from '@square/dashboard-data/serializers/channels/base-channel-serializer';
export default BaseChannelSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    objectMaps: {
      embedded: 'always'
    }
  },
  modelNameFromPayloadKey() {
    return 'channels/platform-object';
  }
});